import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest_ } from './http'
import { baseurl } from '../constants/constants';

export function setData(items, name) {
    return {
        type: ActionTypes.SET_DATA,
        name: name,
        items: items
    }
}

const get_ = (data, controller) => {
    return (dispatch) => {
        //dispatch(loading());
        getRequest(data, controller).then(
            (response) => {

            },
            (err) => {

            }
        );
    }
};

const post_ = (data, controller) => {
    return (dispatch) => {
        let dominio = window.localStorage.getItem('ari_app_dominio').split('http');
        let url = "";
        console.log(dominio);
        if (dominio.length > 1) {
            url = window.localStorage.getItem('ari_app_dominio');
        } else {
            url = "https://" + window.localStorage.getItem('ari_app_dominio');

        }
        console.log(`${url}`);
        postRequest_(data, controller).then(
            (response) => {
                if (data.typeOption == "login") {
                    if (response.data.success) {

                        window.localStorage.setItem('ari_app_token', response.data.token);
                        window.localStorage.setItem('ari_app_dominio', data.dominio);
                        window.localStorage.setItem('ari_app_new_login', 1);
                        window.localStorage.setItem('islogued', 'true');
                        window.localStorage.setItem('data_login_ari_app', JSON.stringify({
                            id: response.data.user_data.id,
                            is_admin: response.data.user_data.is_admin ? response.data.user_data.is_admin : false,
                            email: response.data.user_data.email,
                            first_name: response.data.user_data.first_name,
                            last_name: response.data.user_data.last_name,
                            username: response.data.user_data.username,
                            contact_number: response.data.user_data.contact_number,
                            password: data.password,
                            dominio: data.dominio,
                            time_end: response.data.pos_settings.time_end ? response.data.pos_settings.time_end : 16,
                            time_init: response.data.pos_settings.time_init ? response.data.pos_settings.time_init : 8,
                            time_location_app: response.data.pos_settings.time_location_app ? response.data.pos_settings.time_location_app : 10,
                            is_super_admin: response.data.user_data.is_super_admin ? response.data.user_data.is_super_admin : false
                        }));

                        window.localStorage.setItem('ari_app_permissions', response.data.permissions ? JSON.stringify(response.data.permissions) : '[]');
                        window.localStorage.setItem('ari_app_enabled_modules', response.data.enabled_modules ? JSON.stringify(response.data.enabled_modules) : '{}');
                        window.location.href = baseurl() + "/home";

                    } else {
                        dispatch(setData({
                            response: { Msg: response.data.msg, redirect: false, success: response.data.success },
                            simpleToast: true
                        }));
                        window.localStorage.setItem('islogued', 'false');
                        window.localStorage.setItem('data_login_ari_app', null);
                        window.localStorage.setItem('ari_app_dominio', 'false');
                        window.localStorage.setItem('ari_app_token', 'false');
                    }
                }
            },
            (err) => {

                console.log(err);
                if (err.response) {
                    if (err.response.status == 500) {
                        dispatch(setData({
                            response: { Msg: err.response.data.message, redirect: false, success: 0 },
                            simpleToast: true
                        }));
                    }
                }

                if (err.code == 'ERR_NETWORK') {
                    dispatch(setData({
                        response: { Msg: "Sin Conección al Servidor", redirect: false, success: 0 },
                        simpleToast: true
                    }));
                }
            }
        );
    }
};

export default {
    get_,
    post_,
    setData
}
